<template lang="html">
  <div class="scadenziario">

    <Row>
      <Col :span="12">
        <b style="display: block; margin: 10px 0 5px">Cosa vuoi vedere?</b>
        <Select v-model="filters.is_incoming" style="max-width: 140px">
          <Option :value="0">Pagamenti da effettuare</Option>
          <Option :value="1">Pagamenti da ricevere</Option>
        </Select>

        <b style="display: block; margin: 10px 0 5px">Filtra cliente</b>
        <Select v-model="filters.contact_id" style="min-width: 340px" :filterable="true" :clearable="true">
          <Option v-for="c in contacts" :key="c.id" :value="c.id">{{ c.name }}</Option>
        </Select>


        <b style="display: block; margin: 10px 0 5px">Visualizza solo i pagamenti da effettuare entro il:</b>
        <div style="position: relative">
          <LocalDate v-model="filters.before_date"/>
        </div>
      </Col>

      <Col :span="12">
        <div style="text-align: right">
          <Button @click.native="$root.$emit('invoice.show', {is_a:'inv'})" type="info">
            <Icon type="plus"></Icon>
            Fattura
          </Button>
          <Button @click.native="$root.$emit('invoice.show', {is_a:'nacc'})" type="error">
            <Icon type="plus"></Icon>
            Nota di credito
          </Button>
          <Button @click.native="$root.$emit('invoice.show', {is_a:'ric'})" type="purple">
            <Icon type="plus"></Icon>
            Ricevuta
          </Button>
        </div>
      </Col>
    </Row>


    <div class="" style="margin: 1em 0">
      <table class="my-table">
        <thead>
          <tr>
            <th style="width: 150px">Tipologia</th>
            <th >N/PR fatt.</th>
            <th >Scadenza</th>
            <th >Data fattura</th>
            <th>{{(filters.type == 'sent' ? 'Cliente' : 'Fornitore')}}</th>
            <th>Rata (tot. {{ !payments ? '...' : $n(_.sum(payments.map(p => p.amount)), 'currency') }})</th>
            <!-- <th>Stato<br>pagamenti</th> -->
            <th style="width: 50px" class="print-hide"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="inv in over_payments" class="text-error">
            <td>
              <span v-if="inv.is_a == 'inv'">Fattura</span>
              <span v-else-if="inv.is_a == 'nacc'">Nota di credito</span>
              <span v-else-if="inv.is_a == 'ric'">
                <a v-if="inv.is_a='ric'" @click="$utils.print('print-ric/'+inv.id)">
                  <Icon type="ios-printer"/>&nbsp; Ricevuta
                </a>
              </span>
              <span v-else><code>{{ inv.is_a }}</code></span>
              <span > {{ inv.type == 'rec' ? 'ric.' : 'emes.' }}</span>
            </td>
            <td> N.{{inv.number }} P.{{inv.protocol }} </td>
            <td>-</td>
            <td>{{ $d(Date.maintain(inv.date)) }}</td>
            <td>
              {{ inv.contact_name }}
            </td>
            <td>{{ $n(inv.total - inv.total_paid, 'currency') }}</td>
            <!-- <td>{{ $n(inv.total_paid, 'currency') }} su {{ $n(inv.total, 'currency') }}</td> -->
            <td class="print-hide">
              <Button
              @click="$root.$emit('invoice.show', inv)"
              type="primary">
                <Icon type="edit"/>
              </Button>
            </td>
          </tr>
          <tr v-if="!payments">
            <td colspan=3>
              Caricamento pagamenti...
            </td>
          </tr>
          <tr v-else-if="!payments.length">
            <td colspan=3>
              Nessuna scadenza trovata
            </td>
          </tr>
          <tr v-else v-for="t in payments" :key="t.id">
            <td>
              <span v-if="t.invoice.is_a == 'inv'">Fattura</span>
              <span v-else-if="t.invoice.is_a == 'nacc'">Nota di credito</span>
              <span v-else-if="t.invoice.is_a == 'ric'">
                <a v-if="t.invoice.is_a='ric'" @click="$utils.print('print-ric/'+t.invoice.id)">
                  <Icon type="ios-printer"/>&nbsp; Ricevuta
                </a>
              </span>
              <span v-else><code>{{ t.invoice.is_a }}</code></span>
              <span > {{ t.invoice.type == 'rec' ? 'ric.' : 'emes.' }}</span>
            </td>
            <td> N.{{t.invoice.number }} P.{{t.invoice.protocol }} </td>
            <td>{{ $d(Date.maintain(t.date)) }}</td>
            <td>{{ $d(Date.maintain(t.invoice.date)) }}</td>
            <td>
              {{ t.invoice.contact_name }}
            </td>
            <td>{{ $n(t.amount, 'currency') }}</td>
            <!-- <td>{{ $n(t.invoice.total_paid, 'currency') }} su {{ $n(t.invoice.total, 'currency') }}</td> -->
            <td class="print-hide">
              <Button
              @click="$root.$emit('invoice.show', t.invoice)"
              type="primary">
                <Icon type="edit"/>
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
      <Spin size="large" fix v-if="loading"/>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      payments: null,
      filters: {
        company_id: this.$store.company.id,
        is_incoming: 0,
      },
      contacts: [],
      over_payments: [],
    }
  },

  mounted() {
    this.refreshPayments()
    this.$root.$on('invoices', this.refreshPayments)
    this.refreshContacts()
    this.$root.$on('contacts', this.refreshContacts)
  },
  beforeDestroy() {
    this.$root.$off('invoices', this.refreshPayments)
    this.$root.$off('contacts', this.refreshContacts)
  },

  methods: {
    refreshPayments(page) {
      var params = Object.assign({
      }, this.filters)
      this.loading = true
      this.$http.get('payments', {params}).then(res => {
        this.payments = res.data
      }).finally(res => {
        this.loading = false
      })
      this.$http.get('over-payments', {params}).then(res => {
        this.over_payments = res.data
      })
    },
    refreshContacts(page) {
      var params = {
        company_id: this.$store.company.id,
        is_a: 'inv',
        unpaid: 1,
      }
      this.$http.get('contact-names', {params}).then(res => {
        this.contacts = res.data
      })
    },

    isIncoming (p) {
      let x = p.invoice.type == 'sent'
      if (p.invoice.is_a == 'nacc') x = !x
      return x
    }
  },

  watch: {
    filters: {
      deep: true,
      handler: require('lodash').debounce(function() {
        this.refreshPayments()
      }, 300)
    }
  }
}
</script>

<style lang="scss">
@media print {

}
</style>
